import React from 'react';
import axios from 'axios';

import config from '../../../config';
import { getCustomToast } from '../../../components/ErrorMessage';

let cached = null;

export default function useTransportationJson() {
  const [data, setData] = React.useState(cached);

  React.useEffect(() => {
    if (data) return;

    axios
      .get(config.transportationUrl, {
        headers: {
          'Access-Control-Allow-Origin': '*',
        },
      })
      .then(({ data: { data } }) => {
        setData(data);
        cached = data;
      })
      .catch(() => {
        getCustomToast('An error occurred. Please try refreshing the page again!', 'error');
      });
  }, []);

  return data;
}



// WEBPACK FOOTER //
// ./src/screens/Transportation/Common/useTransportationJson.js